<template>
  <div>
    <div class="greeting" v-if="lang === 'en'">
      <div>
        <p>
          Welcome to EMAF’s submission platform!
        </p>
        <p>
          The submission phase for this year's festival is now over.
        </p>
      </div>
    </div>
    <div class="greeting" v-else>
      <div>
        <p>
          Willkommen auf der Einreichplattform des EMAF!
        </p>
        <p>
          Die Einreichphase für das diesjährige Festival ist abgeschlossen.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Home',
  computed: {
    lang () {
      return this.$store.state.language
    }
  }
}
</script>

<style scoped>
.greeting {
  display: flex;
  justify-content: space-around;
  align-items: center;
  position: absolute;
  left: 0;
  top: 3rem;
  right: 0;
  bottom: 0;
  color: var(--bg);
  background: var(--acc);
  background-image: url('../assets/img/emaf_submisson-form_bg.jpg');
  background-position: center center;
  background-size: cover
}

.greeting p {
  text-align: center;
  font-size: 1.6rem;
}
</style>
